import { render, staticRenderFns } from "./ShipmentItemCommentsSection.vue?vue&type=template&id=3079400a&scoped=true&"
import script from "./ShipmentItemCommentsSection.vue?vue&type=script&lang=js&"
export * from "./ShipmentItemCommentsSection.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentItemCommentsSection.vue?vue&type=style&index=0&id=3079400a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079400a",
  null
  
)

export default component.exports